export default "__VITE_ASSET__DnD1nJAM__"